<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import Select from 'primevue/select';
import { peopleBackend } from '@/backend/people.backend';

export interface Department {
  id: number;
  name: string;
}

interface Props {
  modelValue: string;
}

interface Emits {
  (e: 'update:modelValue', value: string): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const departments = ref<Department[]>([]);
const loading = ref(false);

// Computed for dropdown options
const departmentOptions = computed(() => {
  const options = [
    { label: 'All Departments', value: 'all' }
  ];
  
  if (departments.value?.length > 0) {
    departments.value.forEach(dept => {
      options.push({
        label: dept.name,
        value: dept.id.toString()
      });
    });
  }
  
  return options;
});

// Computed for v-model binding
const selectedDepartment = computed({
  get: () => props.modelValue,
  set: (value: string) => emit('update:modelValue', value)
});

// Fetch departments on mount
onMounted(async () => {
  loading.value = true;
  try {
    departments.value = await peopleBackend.departments() as Department[];
  } catch (error) {
    console.error('Failed to load departments:', error);
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <Select
    v-model="selectedDepartment"
    :options="departmentOptions"
    optionLabel="label"
    optionValue="value"
    :disabled="loading"
    placeholder="Select department"
    class="w-48"
  />
</template>

<style scoped>

</style>